const Timezones = [
	{
		"id": -12,
		"label": "GMT-12",
		"value": 720
	},
	{
		"id": -11,
		"label": "GMT-11",
		"value": 660
	},
	{
		"id": -10,
		"label": "GMT-10",
		"value": 600
	},
	{
		"id": -9,
		"label": "GMT-9",
		"value": 540
	},
	{
		"id": -8,
		"label": "GMT-8",
		"value": 480
	},
	{
		"id": -7,
		"label": "GMT-7",
		"value": 420
	},
	{
		"id": -6,
		"label": "GMT-6",
		"value": 360
	},
	{
		"id": -5,
		"label": "GMT-5",
		"value": 300
	},
	{
		"id": -4,
		"label": "GMT-4",
		"value": 240
	},
	{
		"id": -3,
		"label": "GMT-3",
		"value": 180
	},
	{
		"id": -2,
		"label": "GMT-2",
		"value": 120
	},
	{
		"id": -1,
		"label": "GMT-1",
		"value": 60
	},
	{
		"id": 0,
		"label": "GMT",
		"value": 0
	},
	{
		"id": 1,
		"label": "GMT+1",
		"value": -60
	},
	{
		"id": 2,
		"label": "GMT+2",
		"value": -120
	},
	{
		"id": 3,
		"label": "GMT+3 Moscow",
		"value": -180
	},
	{
		"id": 4,
		"label": "GMT+4",
		"value": -240
	},
	{
		"id": 5,
		"label": "GMT+5",
		"value": -300
	},
	{
		"id": 6,
		"label": "GMT+6 Asia/Almaty",
		"value": -360
	},
	{
		"id": 7,
		"label": "GMT+7",
		"value": -420
	},
	{
		"id": 8,
		"label": "GMT+8",
		"value": -480
	},
	{
		"id": 9,
		"label": "GMT+9",
		"value": -540
	},
	{
		"id": 10,
		"label": "GMT+10",
		"value": -600
	},
	{
		"id": 11,
		"label": "GMT+11",
		"value": -660
	},
	{
		"id": 12,
		"label": "GMT+12",
		"value": -720
	}
]

export default Timezones